import { initialiseCheckout } from 'actions/CheckoutActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import React, { ComponentProps, useCallback } from 'react'
import MultiRoomOfferCheckoutButton from './MultiRoomOfferCheckoutButton'
import { isAccommodationItem, isFlightItem, isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import { addToUserCart } from 'actions/UserCartActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import TextButton from 'LuxKit/Button/TextButton'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { hotelItemContextByPackageView, addToCartWithContext } from 'analytics/snowplow/events'
import * as Analytics from 'analytics/analytics'
import { isNonNullable } from 'lib/array/arrayUtils'
import { getActivePackagesByRoom, PackageOptionViewByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'
import { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { pluralizeToString } from 'lib/string/pluralize'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  disabled?: boolean
  rooms: Array<OfferPageRoom>
  activePackagesByRoom: PackageOptionViewByRoom
  flightPrice?: number
}

function MultiRoomOfferSelectRoomsButton(props: Props) {
  const { disabled, rooms, activePackagesByRoom, ...rest } = props
  const dispatch = useAppDispatch()

  const addItemsToUserCart = useCallback((items: Array<App.Checkout.AnyItem>, connectRooms: boolean) => {
    const offerId = items.find(isAccommodationItem)!.offerId
    if (items.some(isFlightItem)) {
      // Pick regular flow and final decision to pay or only add to cart to be made at end of flight selection
      dispatch(initialiseCheckout(items, { mode: 'vertical-select', connectedRoomOfferIds: connectRooms ? [offerId] : [] }))
      dispatch(navigateToCheckout({ skipSpoofedModal: true }))
    } else {
      const contextItems = items
        .filter(isInstantBookingLEHotelItem)
        .map(item => {
          if ('id' in item.occupancy) {
            return hotelItemContextByPackageView(item, activePackagesByRoom[item.occupancy.id], true)
          }
        })
        .filter(isNonNullable)
      Analytics.trackEvent(addToCartWithContext(contextItems))
      dispatch(addToUserCart(
        items,
        false, // skipNotification
        connectRooms
      ))
    }
  }, [activePackagesByRoom, dispatch])

  return <MultiRoomOfferCheckoutButton
    {...rest}
    activePackagesByRoom={activePackagesByRoom}
    kind="primary"
    type="submit"
    onProceedToBooking={addItemsToUserCart}
    disabled={disabled}
  >
    Select {pluralizeToString('room', rooms.length)}
  </MultiRoomOfferCheckoutButton>
}

export default withOfferPageAndReduxState((state, appState) => ({
  rooms: state.rooms,
  activePackagesByRoom: getActivePackagesByRoom(state, appState),
}), MultiRoomOfferSelectRoomsButton)
